import React from "react";
import { DialogModal } from "@pushpress/shared-components";
import { toast } from "react-toastify";
import { defaultToastOptions, extractError } from "../../utils/misc";
import { useDeleteLocationMutation } from "../../apis/locationsApi.hooks";

interface LocationDeleteModalProps {
  locationUuid?: string;
  visible: boolean;
  onClose: VoidFunction;
  onSuccess: VoidFunction;
}

const LocationDeleteModal = (props: LocationDeleteModalProps) => {
  const { locationUuid, visible, onClose, onSuccess } = props;

  const deleteMutation = useDeleteLocationMutation();

  const handleDelete = async () => {
    try {
      if (!locationUuid) {
        throw new Error("Empty uuid");
      }
      await deleteMutation.mutateAsync(locationUuid);
      toast.success("Location deleted", defaultToastOptions);
      onSuccess();
    } catch (error) {
      toast.error(extractError(error), defaultToastOptions);
    }
  };

  return (
    <DialogModal
      visible={visible}
      title="Are you sure you want to delete this location?"
      loading={deleteMutation.isLoading}
      primaryHandler={handleDelete}
      primaryBtnTitle="Delete"
      secondaryBtnTitle="Go Back"
      secondaryHandler={onClose}
      closeModal={onClose}
    />
  );
};

export default LocationDeleteModal;
